import { render, staticRenderFns } from "./WinBet.vue?vue&type=template&id=6bdb96ca&"
import script from "./WinBet.vue?vue&type=script&lang=js&"
export * from "./WinBet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports